

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.DYaiEJK0.js","_app/immutable/chunks/Cew_q46a.js","_app/immutable/chunks/DiR_Syld.js","_app/immutable/chunks/DHDEAeFQ.js","_app/immutable/chunks/zAv0u1wk.js","_app/immutable/chunks/B6Ikv-5C.js","_app/immutable/chunks/BwtdicTf.js","_app/immutable/chunks/D7_98-kq.js","_app/immutable/chunks/BELN90BF.js","_app/immutable/chunks/DcKRL2at.js"];
export const stylesheets = [];
export const fonts = [];
